import DataTable, { TableColumn } from 'react-data-table-component';

import customStyles from '../../../components/FilterDataTable/CustomTableStyles';
import CustomExpander from '../../../components/FilterDataTable/CustomExpander/CustomExpander';

interface FilterObjectDocsTable<T> {
  columns: TableColumn<T>[];
  data: T[];
  isLoading: boolean;
  expandableRows?: boolean;
  expandableRowsComponent?: React.FC<{ data: T }>;
}

function FilterDataTableObjectDocs<T>({
  columns,
  data,
  isLoading,
  expandableRows = false,
  expandableRowsComponent,
}: FilterObjectDocsTable<T>) {
  return (
    <div className="p-3">
      <DataTable
        columns={columns}
        data={data}
        progressPending={isLoading}
        sortServer
        customStyles={customStyles}
        expandableRows={expandableRows}
        expandableRowsComponent={expandableRowsComponent}
        expandableIcon={{
          collapsed: <CustomExpander isExpanded={false} />,
          expanded: <CustomExpander isExpanded />,
        }}
        dense
      />
    </div>
  );
}

export default FilterDataTableObjectDocs;
